import { FC } from 'react'
import Marquee from 'react-fast-marquee';
import { Icon } from '@iconify/react';

interface Props {
    text: string
}

const Notice: FC<Props> = ({ text }) => {
    return (
        <div className='notice-wrapper'>
            <div className="notice-icon">
                <Icon icon="basil:bullhorn-outline" width={20} />
            </div>
            <div className="notice-text">
                <Marquee pauseOnHover gradient={false}>{text}</Marquee>
            </div>
        </div>
    )
}

export default Notice
